
<h1 mat-dialog-title>Delete Program </h1>
<p>Click below to confirm the deleting of this program.</p>
<div>
  <button mat-raised-button class="functional-button-dark" (click)="Confirm()" [mat-dialog-close]="data"> Delete</button>
  <button mat-raised-button class="functional-button" (click)="Cancel()"> Cancel</button>
</div>